// context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('language') || 'tr';
  });

  const changeLanguage = (newLanguage) => {
    console.log('Changing language from', currentLanguage, 'to', newLanguage);
    
    setCurrentLanguage(newLanguage);
    
    localStorage.setItem('language', newLanguage);
    
    window.dispatchEvent(new CustomEvent('languageChanged', { 
      detail: { 
        language: newLanguage,
        previousLanguage: currentLanguage 
      } 
    }));
    
    console.log('Language changed successfully to:', newLanguage);
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'language' && event.newValue) {
        console.log('Language changed from storage:', event.newValue);
        setCurrentLanguage(event.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && savedLanguage !== currentLanguage) {
      console.log('Setting language from localStorage:', savedLanguage);
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const contextValue = {
    currentLanguage,
    changeLanguage,
    setLanguage: changeLanguage,
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};